import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyToValuePipe } from './pipes/key-to-value.pipe';

const COMPONENTS = [

]

const PIPES = [
  KeyToValuePipe,
]

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    ...PIPES,
  ],
  exports: [
    ...PIPES,
  ],
})
export class SharedModule { }
